import script from "./TeacherSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./TeacherSidebar.vue?vue&type=script&setup=true&lang=js"

import "./TeacherSidebar.vue?vue&type=style&index=0&id=28209082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28209082"]])

export default __exports__